import { UserOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import OrderPersonPicker from 'components/pages/dashboard/ParcelOrder/components/orderPersonPicker/OrderPersonPicker';
import { client } from 'global/Models/clientModel';
import { FC, useCallback, useState } from 'react';

interface IOrderClientBox {
  setClient: (_client?: client) => void;
  client?: client;
  title: 'فرستنده' | 'گیرنده';
}

const OrderClientBox: FC<IOrderClientBox> = ({ client, setClient, title }) => {
  //states
  const [showModal, setShowModal] = useState<boolean>(false);

  //function
  const toggleModal = useCallback(() => setShowModal((prevState) => !prevState), []);
  const handleDelete = useCallback(() => setClient(undefined), []);

  return (
    <div>
      <div className='transition-shadow w-full lg:w-[200px] duration-300 rounded-lg shadow-none flex justify-center bg-t-bg-color hover:shadow-lg border border-t-border-color-base'>
        {!client && (
          <span className='flex items-center gap-1 p-2 cursor-pointer ' onClick={toggleModal}>
            <UserOutlined />
            فرد {title}
          </span>
        )}
        {client && (
          <div className='w-full'>
            <div className='p-2 cursor-pointer' onClick={toggleModal}>
              <span className='block whitespace-nowrap overflow-ellipsis lg:w-[134px] overflow-hidden'>
                <UserOutlined />
                {client.fullName}
              </span>
              <span className='block text-xs text-t-secondary-text-color'>{client.mobile}</span>
              <span className='block text-xs text-t-secondary-text-color'>{client.telephonNumber}</span>
            </div>
            <hr className='my-1' />
            <div className='flex items-center justify-center gap-2 py-1'>
              <Popconfirm title='حذف شود؟' onConfirm={handleDelete}>
                <span className='block text-xs text-center cursor-pointer text-t-error-color inherit-color'>حذف</span>
              </Popconfirm>
              <span className='block text-xs text-center cursor-pointer text-t-secondary-color inherit-color' onClick={toggleModal}>
                ویرایش
              </span>
            </div>
          </div>
        )}
      </div>
      <OrderPersonPicker close={toggleModal} visible={showModal} setClient={setClient} />
    </div>
  );
};

export default OrderClientBox;
